module.exports = __webpack_public_path__ + "static/media/icon-medidor-orange.4f9b45c3.svg";